import type { ColumnType } from 'antd/lib/table';
import { TFunction } from 'i18next';

export const emailColumn = <T extends { email: string }>(t: TFunction): ColumnType<T> => ({
  title: t('Email'),
  dataIndex: 'email',
});
